import { ErrorType } from 'data/App/types'

import { PaymentActions } from './actions'
import { FETCH_PAYMENT, FETCH_PAYMENT_ERROR, FETCH_PAYMENT_SUCCESS } from './actionTypes'
import { Payment } from './types'

type PaymentInnerState = {
  data?: Payment
  error?: ErrorType
  loading: boolean
}
const INITIAL_STATE = {
  loading: false
}

// Example: { '1': { loading: false, data: {...} }, '2': { loading: true } }
export type PaymentState = Partial<Record<string, PaymentInnerState>>

const innerReducer = (state: PaymentInnerState = INITIAL_STATE, action: PaymentActions) => {
  switch (action.type) {
    case FETCH_PAYMENT:
      return {
        ...state,
        loading: true
      }
    case FETCH_PAYMENT_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      }
    case FETCH_PAYMENT_ERROR:
      return { ...state, error: action.payload.error, loading: false }
    default:
      return state
  }
}

export default (state: PaymentState = {}, action: PaymentActions) => {
  if (!action) return state
  const { id } = action.payload
  if (!id) return state
  return {
    ...state,
    [id]: innerReducer(state[id], action)
  }
}
